module.exports = __webpack_public_path__ + "static/media/Hybird&Petrol.b979b5fc.svg";